<script>
    import * as m from '@app/paraglide/messages.js';
    import {
        eventGroupState
    } from '@app/store/eventGroupStore.svelte.js';
    import {
        projectState
    } from '@app/store/projectStore.svelte.js';
    import { filterState } from '@app/store/editorStore.svelte.js';
    import { getFilteredEventIndices } from '@app/lib/eventValidation.js';
    import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();
    
function selectAll() {
    try {
        const events = eventGroupState[projectState.selected].events;
        const eventGroup = eventGroupState[projectState.selected];
        eventGroupState[projectState.selected].selected = getFilteredEventIndices(events, eventGroup, filterState);
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }        
}
</script>
    
<a
    id="selectAllBtn"
    class="dropdown-item"
    role="button"
    aria-label={m.context_menu_select_all_label()}
    href="#!/"
    onclick={selectAll}>
    {m.context_menu_select_all()}
</a>
